import { render, staticRenderFns } from "./CustomLayout.vue?vue&type=template&id=fcdc8950&"
import script from "./CustomLayout.vue?vue&type=script&lang=js&"
export * from "./CustomLayout.vue?vue&type=script&lang=js&"
import style0 from "./CustomLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports